import { render, staticRenderFns } from "./novel_collect_list.vue?vue&type=template&id=6f90d3fc&scoped=true"
import script from "./novel_collect_list.vue?vue&type=script&lang=js"
export * from "./novel_collect_list.vue?vue&type=script&lang=js"
import style0 from "./novel_collect_list.vue?vue&type=style&index=0&id=6f90d3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90d3fc",
  null
  
)

export default component.exports